// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"14b2d76e","154":"cf421b8f","328":"c6308eae","376":"9a37d4b6","574":"9f10729f","578":"8546bd9a","668":"4761e278","724":"052bdf7b","892":"b27d702a","910":"9006078b","916":"8c2c0826","929":"4039df53","965":"267cd81a"}[chunkId] + ".chunk.js";
};